import { render, staticRenderFns } from "./SysCheckRuleTestModal.vue?vue&type=template&id=3732c01b&scoped=true&"
import script from "./SysCheckRuleTestModal.vue?vue&type=script&lang=js&"
export * from "./SysCheckRuleTestModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3732c01b",
  null
  
)

export default component.exports